"use client";
import styles from "./MobileCalculatorStyle.module.scss";
import { ArrowDown } from "@/asset/svgs";
import { useEffect, useState } from "react";
import { convertToDecimal } from "@/utils/convertToDecimal";
import Image from "next/image";
import { CryptoCurrency } from "@/service/queries/cryptoCurrencies";

type Props = {
  data: CryptoCurrency;
  coin: string;
};

type QuoteType = "TMN" | "USDT";

const MobileCalculator = ({ data, coin }: Props) => {
  const [showQuotesBox, setShowQuotesBox] = useState(false);
  const [activeQuote, setActiveQuote] = useState<QuoteType>("TMN");
  const [quoteAmount, setQuoteAmount] = useState(0);
  const [calculatorOutput, setCalculatorOutput] = useState<string>("0");

  useEffect(() => {
    if (quoteAmount) {
      if (activeQuote === "TMN")
        setCalculatorOutput(
          convertToDecimal(quoteAmount)
            .dividedBy(Number(data?.price_in_irr) / 10)
            .toFixed(10)
            .toString(),
        );
      else if (activeQuote === "USDT")
        if (data?.crypto_currency_name?.toLowerCase() !== "usdt") {
          setCalculatorOutput(
            convertToDecimal(quoteAmount)
              .dividedBy(Number(data?.price_in_usdt))
              .toFixed(10)
              .toString(),
          );
        } else {
          setCalculatorOutput(
            convertToDecimal(quoteAmount)
              .mul(Number(data?.price_in_irr) / 10)
              .toFixed(10)
              .toString(),
          );
        }
    } else {
      setCalculatorOutput("0");
    }
  }, [
    activeQuote,
    data?.crypto_currency_name,
    data?.price_in_irr,
    data?.price_in_usdt,
    quoteAmount,
  ]);

  const triggerQuotesBox = () => {
    setShowQuotesBox((oldState) => !oldState);
  };

  const chnageQuote = (type: QuoteType) => {
    setActiveQuote(type);
    setShowQuotesBox(false);
  };
  return (
    <div className={styles.MobileCalculator}>
      <div className={styles.title}>محاسبه قیمت</div>
      <div className={styles.inputBoxOne}>
        <input
          type="tel"
          inputMode="tel"
          required
          maxLength={14}
          placeholder="مقدار را وارد کنید"
          onChange={(e) => {
            if (Number(e.target.value) < 0) {
              e.target.value = "";
            }
            setQuoteAmount(Number(e.target.value));
          }}
          min="0"
        />
        <div className={styles.divider}></div>
        <div className={styles.selectQuote}>
          <div className={styles.selectedQuote} onClick={triggerQuotesBox}>
            <ArrowDown width={10} height={6} className={styles.icon} />
            <div className={styles.quote}>
              <Image
                width={24}
                height={24}
                src={`${process.env.APP_STORAGE_URL}/media/static/currency/logos/${activeQuote === "TMN" ? "IRR" : "USDT"}/${activeQuote === "TMN" ? "IRR" : "USDT"}.png`}
                alt="quote-logo"
              />
              <div className={styles.text}>{activeQuote}</div>
            </div>
          </div>
          {showQuotesBox && (
            <div className={styles.listBox}>
              <div
                className={styles.backSurface}
                onClick={() => setShowQuotesBox(false)}
              ></div>
              <div className={styles.list}>
                <div
                  className={styles.listItem}
                  onClick={() => chnageQuote("TMN")}
                >
                  <Image
                    width={30}
                    height={30}
                    src={`${process.env.APP_STORAGE_URL}/media/static/currency/logos/IRR/IRR.png`}
                    alt="quote-logo"
                  />
                  <div className={styles.texts}>
                    <div className={styles.textsItemOne}>TMN</div>
                    <div className={styles.textsItemTwo}>تومان</div>
                  </div>
                </div>
                <div className={styles.divider}></div>
                <div
                  className={styles.listItem}
                  onClick={() => chnageQuote("USDT")}
                >
                  <Image
                    width={30}
                    height={30}
                    src={`${process.env.APP_STORAGE_URL}/media/static/currency/logos/USDT/USDT.png`}
                    alt="quote-logo"
                  />
                  <div className={styles.texts}>
                    <div className={styles.textsItemOne}>USDT</div>
                    <div className={styles.textsItemTwo}>تتر</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles.inputBoxTwo}>
        <div className={styles.label}>
          مقدار{" "}
          {data?.crypto_currency_name?.toLowerCase() === "usdt" &&
          activeQuote === "USDT"
            ? "TMN"
            : data?.crypto_currency_name || coin}
        </div>
        <div className={styles.value}>
          <div className={styles.amount}>{Number(calculatorOutput)}</div>
          <div className={styles.divider}></div>
          <div className={styles.coin}>
            {data?.crypto_currency_name?.toLowerCase() === "usdt" &&
            activeQuote === "USDT"
              ? "TMN"
              : data?.crypto_currency_name || coin}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileCalculator;
